import { render, staticRenderFns } from "./copyrightIp.vue?vue&type=template&id=1e90ce40&scoped=true&"
var script = {}
import style0 from "./copyrightIp.vue?vue&type=style&index=0&id=1e90ce40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e90ce40",
  null
  
)

export default component.exports